import React, { useState } from "react";
import { useLoginMutation } from "../featureSlice/auth/authSlice";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const [login, { isLoading, isError, error }] = useLoginMutation();

  function togglePasswordVisibility() {
    setIsPasswordVisible((prevState) => !prevState);
  }

 const handleLogin = async () => {
  setLoginError("");

  const formdata = new FormData();
  formdata.append("applicationId", "ASG000003AA");
  formdata.append("deviceId", "69f22127-e32f-4fb4-b18e-5186b0b59207");
  formdata.append("userName", userName);
  formdata.append("password", password);

  try {
    const result = await login(formdata).unwrap();

    const token = result?.metaData?.accessTokenInformation?.accessToken; // 👈
    const userDetails = result?.metaData?.userDetails;
    const roleStatus = userDetails?.permissionInformation?.roleInformation?.roleStatus;

    if (roleStatus === true) {
      localStorage.setItem("token", token); 
        localStorage.setItem("userDetails", JSON.stringify(result?.metaData?.userDetails)); // 👈

      navigate("/analytics");
    } else {
      setLoginError("Access denied: Your role status does not allow you to log in.");
    }
  } catch (err) {
    setLoginError(err?.data?.error || "Login failed");
  }
};

  return (
    <div className="grid md:grid-cols-2 text-lightGrey">
      <div className="w-full h-full overflow-hidden">
        <div className="h-screen bg-primary flex items-center justify-center rounded-tr-2xl rounded-br-2xl">
          <img
            alt="login_image"
            src={`${process.env.PUBLIC_URL}/canteen-login.svg`}
          />
        </div>
      </div>

      <div className="bg-white h-full flex items-center justify-center">
        <div className="w-full p-16">
          <h4 className="text-3xl text-primary font-bold">Log In</h4>

          <div className="py-2">
            <input
              type="email"
              value={userName}
              className="rounded-md border px-3 py-2 my-3 w-full outline-none"
              placeholder="Enter email"
              onChange={(e) => setUserName(e.target.value)}
            />

            <div className="relative py-2">
              <input
                value={password}
                type={isPasswordVisible ? "text" : "password"}
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 text-base border border-gray-300 rounded-md outline-none"
              />
              <button
                className="absolute inset-y-0 right-0 flex items-center px-4 text-gray-600"
                onClick={togglePasswordVisibility}
              >
                {isPasswordVisible ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                    />
                  </svg>
                )}
              </button>
            </div>

            

            <p className="text-red-500 font-bold">
              {isError ? error?.data?.error || "Something went wrong." : ""}
              {/* {loginError} */}
            </p>

            <div className="flex items-center justify-center w-full mt-4">
              <button
                onClick={handleLogin}
                disabled={isLoading}
                type="button"
                className="text-white w-1/4 font-bold bg-primary rounded-md text-center py-2 disabled:opacity-60"
              >
                {isLoading ? "Please Wait..." : "Login"}
              </button>
            </div>
          </div>

          <h6 className="pt-14 text-center text-darkgrey text-sm">
            Powered by ThirdEye AI
          </h6>
        </div>
      </div>
    </div>
  );
};

export default Login;